import { render } from "./VirtualCard.vue?vue&type=template&id=422a5bd8"
import script from "./VirtualCard.vue?vue&type=script&lang=js"
export * from "./VirtualCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__